// extracted by mini-css-extract-plugin
export default {"container":"ButtonDocumentation_container__-Oc5U","propertyDivider":"ButtonDocumentation_propertyDivider__7JF-V","warning":"ButtonDocumentation_warning__wVg71"};